import { MediaFileType } from "../enums/MediaFileType";
import { Api } from "./api";

export class MediaUploader {
    static upload(
        type: MediaFileType,
        referenceId: number,
        file: File,
        fileName: string,
        onProgress?: (event: ProgressEvent) => void
    ): Promise<string> {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            const formData = new FormData();

            formData.append("type", type);
            formData.append("referenceId", referenceId.toString());
            formData.append("fileName", fileName);
            formData.append("file", file);

            xhr.open("POST", Api.baseUrl + "/media/upload", true);
            xhr.withCredentials = true;

            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.responseText);
                } else {
                    reject(new Error(`Failed to upload media: ${xhr.responseText}`));
                }
            };

            xhr.onabort = () => {
                reject(new Error("Failed to upload media: Aborted"));
            };

            xhr.onerror = () => {
                reject(new Error("Failed to upload media: Error"));
            };

            if (onProgress && xhr.upload) {
                xhr.upload.onprogress = onProgress;
            }

            xhr.send(formData);
        });
    }
}